import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithMutation, atomWithQuery } from 'jotai-tanstack-query';

import { getAgreementApi, postAgreementApi } from '@flipster/apis/v1/agreement';
import { snackbar } from '@flipster/react/design-system/snackbar';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { getErrorMessage } from '@flipster/utils/error';

import { earnSummaryBunja } from '../../shared/earn/state';

export const pusdtAgreementBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { getEarnSummaryApiAtom, earnSummaryAtom } = bunja.use(earnSummaryBunja);

  const getAgreementApiAtom = atomWithQuery(() => {
    return {
      queryKey: ['getAgreementApi'],
      queryFn: getAgreementApi,
      select: (res) => res.data,
    };
  });

  const postAgreementApiAtom = atomWithMutation((get) => ({
    mutationKey: ['postAgreementApi'],
    mutationFn: postAgreementApi,
    onSuccess: () => {
      get(getAgreementApiAtom).refetch();
      get(getEarnSummaryApiAtom).refetch();
    },
  }));

  const agreementAtom = atom((get) => get(getAgreementApiAtom).data);
  const isAgreedPusdtV1Atom = atom((get) => get(agreementAtom)?.agreed.includes('AGREEMENT_PREMIUM_USDT') ?? false);
  const isAgreedPusdtV2Atom = atom((get) => get(agreementAtom)?.agreed.includes('AGREEMENT_PREMIUM_USDT_V2') ?? false);
  const pusdtTermAgreedAtom = atom((get) => get(earnSummaryAtom)?.pusdtTermAgreed ?? false); // d-day before: AGREEMENT_PREMIUM_USDT 동의 여부, d-day after: AGREEMENT_PREMIUM_USDT_V2 동의 여부

  async function postV2Agreement() {
    const { mutateAsync } = store.get(postAgreementApiAtom);
    try {
      await mutateAsync({ agree: 'AGREEMENT_PREMIUM_USDT_V2' });
    } catch (error) {
      snackbar.error({ message: getErrorMessage(error) });
    }
  }

  return {
    pusdtTermAgreedAtom,
    postV2Agreement,
    isAgreedPusdtV1Atom,
    isAgreedPusdtV2Atom,
  };
});
pusdtAgreementBunja.debugLabel = 'pusdtAgreementBunja';
